import React, { FC } from 'react';
import Modal from 'react-modal';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import {useDialog} from "@/components/dialog/DialogContext.tsx";
import { toast } from "react-toastify";
import closeIcon from '../../images/close.svg';
import {getErrorMessage} from "@/services/utilities/ServiceError.ts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import {getInstallerDownloadUrl} from "@/services/systemService.ts";
import { PLUGIN_MANAGER } from '@/constants/download-constants';

interface PluginDownloadModalProps {
    isOpen: boolean;
    onClose: () => void;
}

interface PluginDownloadModalState {
    id: number;
    name: string;
    downloadName: string;
    downloadTarget: string;
    description: string;
}

const PluginDownloadModal: FC<PluginDownloadModalProps> = ({isOpen, onClose}) => {
    const { translate } = useLocale();
    const dialog = useDialog();
    const downloadItems: PluginDownloadModalState[] = [
        {
            id: 1,
            name: translate.byKey(TranslationKeys.pluginManagerInstaller),
            downloadName: "ClientInstall.Primo.Plugins.exe",
            downloadTarget: PLUGIN_MANAGER,
            description:translate.byKey(TranslationKeys.pluginManagerDescription)
        },
        // {
        //     id: 2,
        //     name: "Firmware Standalone Utility",
        //     downloadName: "Firmware.Utility.Installer.exe",
        //     downloadTarget: STANDALONE_FWUPGRADE,
        //     description: "A utility for updating the firmware and uploading of certificates for supported devices, ensuring they have the latest features and security patches."
        // }
    ];

    const handleDownload = async (item: PluginDownloadModalState) => {
        toast.info(translate.byKey(TranslationKeys.downloadWillStartShortly));
        await getInstallerDownloadUrl(item.downloadTarget, item.downloadName).then((response) => {
            const link = document.createElement("a");
            link.href = response;
            link.download = item.downloadName;
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(response);
        }).catch(error => {
            dialog.pushError({ title: translate.byKey(TranslationKeys.error), message: getErrorMessage(error) });
        });
    }

    return (
        <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
            className="bg-white border-none m-auto shadow select-none outline-none overflow-hidden" >
            <div className={`w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
                <div className="flex flex-row">
                    <p className="pl-3 font-bold font text-white">{translate.byKey(TranslationKeys.downloads)}</p>
                </div>
                <img src={closeIcon} data-testid="modal_closeDownloads" onClick={onClose} className="cursor-pointer mr-2" />
            </div>
            <div className="pb-3" style={{ width: '500px' }}>
                <span className="text-sm text-black px-3">{translate.byKey(TranslationKeys.downloadsSubtitle)}</span>
                <ul className="mt-2 divide-y">
                    {downloadItems.map((item, index) => (
                        <li key={item.id} className={`flex items-center justify-between px-3 py-3 hover:bg-blue-50 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-100'}`}>
                            <div className="flex flex-col">
                                <button
                                    className="text-left font-semibold text-sm text-blue-600 hover:underline focus:outline-none"
                                    onClick={() => handleDownload(item)}>
                                    {item.name}
                                </button>
                                <div className="flex items-center gap-2 text-xs text-gray-500 mt-1">
                                    <span>{item.description}</span>
                                    <FontAwesomeIcon
                                        icon={faDownload}
                                        onClick={() => handleDownload(item)}
                                        className="flex-shrink-0 cursor-pointer"
                                    />
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </Modal>
    )
};

export default PluginDownloadModal;
